<template>
  <a-card class="gather-card" style="width: 100%; margin-bottom: 10px; position: relative">
    <p style="text-align: center; font-weight: bold; font-size: 24px">第{{ customInfo.serialNumber }}集</p>
    <video
      :ref="'vueRef' + customInfo.id"
      id="vueRef"
      :src="customInfo.videoUrl || ''"
      style="width: 100%; height: 150px;"
      controls
    ></video>

    <div class="subtitle-locale">
      <span class="subtitle-locale__label">字幕语言</span>
      <a-select
        v-model="selectedLocale"
        class="subtitle-locale__select"
        placeholder="请选择语言"
        :allowClear="false"
      >
        <a-select-option v-for="item in localeOptions" :key="item.key" :value="item.key">
          {{ item.label }}
        </a-select-option>
      </a-select>
    </div>

    <div class="subtitle-upload-row">
      <span class="subtitle-upload-row__label">{{ currentLocale.label }}字幕：</span>
      <gatherUploadBtn
        :key="selectedLocale + '-' + (customInfo.id || customIndex)"
        :customInfo="customInfo"
        :customIndex="customIndex"
        :customType="currentLocale.type"
        @change="change"
      ></gatherUploadBtn>
      <a
        v-if="currentSubtitleUrl"
        class="subtitle-upload-row__link"
        :href="currentSubtitleUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        查看
      </a>
    </div>

    <p class="update-time">
      更新时间：{{ customInfo.updateTime }}
    </p>
    <a-checkbox @change="onChange" :checked="checked" style="position: absolute; right: 5px; top: 5px">
    </a-checkbox>
  </a-card>
</template>

<script>
import gatherUploadBtn from './gatherUploadBtn'

const LOCALE_OPTIONS = [
  { key: 'zh', label: '中文简体', type: 1, field: 'subtitle' },
  { key: 'en', label: '英文', type: 2, field: 'subtitleEn' },
  { key: 'ab', label: '阿拉伯语', type: 3, field: 'subtitleAb' },
  { key: 'tc', label: '中文繁体', type: 4, field: 'subtitleTc' },
  { key: 'ko', label: '韩语', type: 5, field: 'subtitleKo' },
  { key: 'vi', label: '越南语', type: 6, field: 'subtitleVi' },
  { key: 'fr', label: '法语', type: 7, field: 'subtitleFr' },
  { key: 'jp', label: '日语', type: 8, field: 'subtitleJp' }
]

export default {
  name: 'gatherUpload',
  components: {
    gatherUploadBtn
  },
  props: {
    customInfo: {
      type: Object
    },
    customIndex: {
      type: Number
    },
    checked: {
      type: Boolean
    }
  },
  data () {
    return {
      selectedLocale: 'zh',
      localeOptions: LOCALE_OPTIONS
    }
  },
  computed: {
    currentLocale () {
      return this.localeOptions.find(item => item.key === this.selectedLocale) || this.localeOptions[0]
    },
    currentSubtitleUrl () {
      return this.customInfo && this.customInfo[this.currentLocale.field]
    }
  },
  methods: {
    change () {
      this.$emit('change')
    },
    onChange (e) {
      this.$emit('selectOption', {
        checked: e.target.checked,
        id: this.customInfo.id,
        data: this.customInfo
      })
    }
  }
}
</script>

<style scoped>
.subtitle-locale {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

.subtitle-locale__label {
  flex-shrink: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
}

.subtitle-locale__select {
  flex: 1;
  min-width: 0;
}

.subtitle-upload-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.subtitle-upload-row__label {
  color: rgba(0, 0, 0, 0.85);
  font-size: 13px;
}

.subtitle-upload-row__link {
  font-size: 13px;
}

.update-time {
  margin-top: 12px;
  margin-bottom: 0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
</style>
